'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPath = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var getPath = function getPath(route, args) {
  var result = (0, _lodash.reduce)(args, function (result, value, key) {
    return result.replace(new RegExp('(:' + key + ')(\\?|/|$|:)'), value + '$2');
  }, route); //console.log("Resolved %s to %s", route, result )

  return result;
};

var Routes = function (_React$Component) {
  _inherits(Routes, _React$Component);

  function Routes(props, context) {
    _classCallCheck(this, Routes);

    var _this = _possibleConstructorReturn(this, (Routes.__proto__ || Object.getPrototypeOf(Routes)).call(this, props, context));

    _this.addRouteToHistory(context.router.history, props);

    return _this;
  }

  _createClass(Routes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addRouteToHistory(this.context.router.history, this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props, context) {
      this.addRouteToHistory(context.router.history, props);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        routes: this.props.routes
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    } // TODO - This looks like it might be a bug,
    // should all callers be passing in props to be used?

  }, {
    key: 'addRouteToHistory',
    value: function addRouteToHistory(history, props) {
      if (history && !history.route) {
        var self = this;

        history.route = function (name, args) {
          this.push(getPath(self.props.routes[name], args));
        };
      }
    }
  }]);

  return Routes;
}(_react2.default.Component);

Routes.childContextTypes = {
  routes: _propTypes2.default.object
};
Routes.contextTypes = {
  router: _propTypes2.default.object
};
exports.default = Routes;
exports.getPath = getPath;